import styled from 'styled-components'
import Text from '../atoms/Text'
import EditableTitleInput from '../atoms/EditableTitleInput'

const Container = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.neutral[200]};
  padding: 20px;
  text-align:left;
`
const DateWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 8px;
`

const RecordingMetaHeader = ({ title, recordedAt, totalTime, onChange }) => {
  return (
    <Container>
      <EditableTitleInput title={title} onChange={onChange}/>
      <DateWrapper>
        <Text variant="body2" color="alternative">{recordedAt}</Text>
        <Text variant="body2" color="alternative">&#183;</Text>
        <Text variant="body2" color="alternative">{totalTime}</Text>
      </DateWrapper>
    </Container>
  )
}

export default RecordingMetaHeader
